
export default function AboutSection() {
  return (
    <section id="about" className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
            Smoother Travel Has Taken
            <span className="text-[#2C2CE8]"> Flyte</span>
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed max-w-4xl mx-auto">
            Flyte flips the script—anticipate disruption, act quickly, keep moving.
          </p>
        </div>

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
          {/* Vision Card */}
          <div className="bg-white rounded-3xl p-10 shadow-xl border border-gray-100">
            <div className="text-center mb-6">
              <div className="w-12 h-12 bg-[#2C2CE8] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-eye-line text-white text-2xl"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900">Our Vision</h3>
            </div>
            <p className="text-gray-600 leading-relaxed text-2xl text-center">
              Trusted real-time disruption intelligence. For every traveler. Every trip.
            </p>
          </div>

          {/* Mission Card */}
          <div className="bg-white rounded-3xl p-10 shadow-xl border border-gray-100 text-[#0A0A6B]">
            <div className="text-center mb-6">
              <div className="w-12 h-12 bg-[#2C2CE8] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-rocket-line text-white text-2xl"></i>
              </div>
              <h3 className="text-3xl font-bold">Our Mission</h3>
            </div>
            <p className="text-[#0A0A6B]/70 leading-relaxed text-2xl text-center">
              Utilize the power of AI to forecast risk, unify options, and execute rebooking—reducing stress and maximizing saved time and recovered value.
            </p>
          </div>
        </div>

        {/* How We're Different */}
        <div className="text-center mb-16">
          <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12">How We Differ</h3>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="group">
              <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 h-full transition-all duration-300 group-hover:shadow-xl group-hover:-translate-y-2">
                <div className="w-20 h-20 bg-gradient-to-br from-[#0A0A6B] to-[#2C2CE8] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-radar-line text-white text-3xl"></i>
                </div>
                <h4 className="text-2xl font-bold text-gray-900 mb-4">Beyond Flight Tracking</h4>
                <p className="text-gray-600 leading-relaxed">
                  Flight tracking reacts. Flyte forecasts, keeping you one step ahead.
                </p>
              </div>
            </div>

            <div className="group">
              <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 h-full transition-all duration-300 group-hover:shadow-xl group-hover:-translate-y-2">
                <div className="w-20 h-20 bg-gradient-to-br from-[#5375EE] to-[#2C2CE8] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-user-location-line text-white text-3xl"></i>
                </div>
                <h4 className="text-2xl font-bold text-gray-900 mb-4">Built For Passengers</h4>
                <p className="text-gray-600 leading-relaxed">
                  Airlines wait and withhold. Flyte informs and empowers.
                </p>
              </div>
            </div>

            <div className="group">
              <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 h-full transition-all duration-300 group-hover:shadow-xl group-hover:-translate-y-2">
                <div className="w-20 h-20 bg-gradient-to-br from-[#0A0A6B] to-[#5375EE] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-rocket-2-line text-white text-3xl"></i>
                </div>
                <h4 className="text-2xl font-bold text-gray-900 mb-4">Early Advantage</h4>
                <p className="text-gray-600 leading-relaxed">
                  With Flyte, you're first to know and first to secure the best alternatives.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center">
          <div className="bg-white rounded-2xl p-12 border border-gray-100 shadow-xl flex flex-col justify-center min-h-[200px]">
            <h4 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-gray-900">
              Don't get caught in the chaos.
            </h4>
            <p className="text-xl text-gray-600 mb-6 max-w-2xl mx-auto">
              Leave behind disruptions, hollow vouchers, and gate agent dead ends.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}
